import React from 'react';
import '../styles/HealthGuideCard.css';

const HealthGuideCard: React.FC = () => {
  return (
    <div className="health-guide-card">
      <div className="guide-content">
        <div className="guide-icon">💡</div>
        <div className="guide-text">
          <h4>让健康档案更完整</h4>
          <p>随时补充最新资料，获取个性化健康建议</p>
        </div>
      </div>
    </div>
  );
};

export default HealthGuideCard; 